export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10887.49dae9cc.jpg";